import { createAction, props } from '@ngrx/store';
import { Field } from '../_models/field';

// Action types
export const loadFields = createAction('[Field] Load Fields', props<{ year: number | null }>());

export const loadFieldsThinCrops = createAction(
  '[Field] Load Fields Thin Crops',
  props<{ fields: Field[] }>()
);

export const loadFieldsSuccess = createAction(
  '[Field] Load Fields Success',
  props<{ fields: Field[] }>()
);
export const loadFieldsFailure = createAction(
  '[Field] Load Fields Failure',
  props<{ error: any }>()
);

export const loadField = createAction(
  '[Field] Load Field',
  props<{ id: number; year?: number | null }>()
);
export const loadFieldSuccess = createAction(
  '[Field] Load Field Success',
  props<{ field: Field }>()
);
export const loadFieldFailure = createAction('[Field] Load Field Failure', props<{ error: any }>());

export const addField = createAction('[Field] Add Field', props<{ field: Field }>());
export const addFieldSuccess = createAction('[Field] Add Field Success', props<{ field: Field }>());
export const addFieldFailure = createAction('[Field] Add Field Failure', props<{ error: any }>());

export const updateField = createAction('[Field] Update Field', props<{ field: Field }>());
export const updateFieldSuccess = createAction(
  '[Field] Update Field Success',
  props<{ field: Field }>()
);
export const updateFieldFailure = createAction(
  '[Field] Update Field Failure',
  props<{ error: any }>()
);

export const deleteField = createAction('[Field] Delete Field', props<{ id: number }>());
export const deleteFieldSuccess = createAction(
  '[Field] Delete Field Success',
  props<{ id: number }>()
);
export const deleteFieldFailure = createAction(
  '[Field] Delete Field Failure',
  props<{ error: any }>()
);
